export default "__VITE_ASSET__42d2802b__"